import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Map as MapIcon, BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import ModonLogo from './ModonLogo';

export default function SiteFooter({ showPublicLinks }) {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const dir = i18n.language === 'en' ? 'ltr' : 'rtl';
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const shouldShowLinks = showPublicLinks !== undefined ? showPublicLinks : isAdmin;
  const isApp = pathname.startsWith('/factory') || pathname.startsWith('/admin');
  return (
    <footer
      dir={dir}
      className={`mt-auto border-t bg-white text-slate-700 ${isApp ? '' : ''}`}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-3 text-xs md:text-sm">
        <div className="flex items-center gap-2">
          <ModonLogo size={36}/>
          <div>
            <div className="font-bold text-slate-900 leading-tight">
              {t('common.developedBy')}: {t('common.modonAuthority')}
            </div>
            <div className="text-slate-500">{t('footer.version')}</div>
          </div>
        </div>

        {shouldShowLinks && (
          <div className="flex items-center gap-4 text-slate-600">
            <Link to="/dashboard" className="hover:text-[#1a4d80] flex items-center gap-1" data-testid="footer-link-dashboard">
              <BarChart3 size={14}/> {t('admin.publicStats')}
            </Link>
            <Link to="/map" className="hover:text-[#1a4d80] flex items-center gap-1" data-testid="footer-link-map">
              <MapIcon size={14}/> {t('admin.map')}
            </Link>
          </div>
        )}

        <div className="text-slate-500">{t('footer.rights')} – {t('common.developedBy')}: {t('common.modonAuthority')}</div>
      </div>
    </footer>
  );
}
